import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import VerifyCertificate
  from "./VerifyCertificate";

import ActivateCertificate
  from "./ActivateCertificate";


function App() {

  return (

    <BrowserRouter>

      <Routes>

        {/* Certificado ya emitido */}
        <Route
          path="/verify/:token"
          element={<VerifyCertificate />}
        />

        {/* Activación inicial por el comprador */}
        <Route
          path="/activar/:token"
          element={<ActivateCertificate />}
        />

      </Routes>

    </BrowserRouter>

  );
}


export default App;